import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

interface useBuscarLogradouroInterface {
  cep: string;
}

export function useBuscarLogradouro(props: useBuscarLogradouroInterface) {
  const fetchData = async () => {
    const BUSCAR_LOGRADOURO = `dadoscomum/logradouro/${props.cep}`;
    const response = await instance.get(BUSCAR_LOGRADOURO);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["buscar_logradouro"],
    refetchOnMount: false,
    enabled: false,
  });
  return query;
}
